import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

let swiperInstance = null;

const initializeSwiperMorningCall = () => {
  const morningCallSection = document.getElementById("morning-call-section");
  if (!morningCallSection) return;

  const wrapper = document.querySelector('.morningCallSwiper .swiper-wrapper');
  const allSlides = Array.from(wrapper.children); // Salva todos os slides

  const initSwiper = () => {
    swiperInstance?.destroy(true, true); // Destroi anterior
    swiperInstance = new Swiper(".morningCallSwiper", {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 32,
      loop: true,
      slideToClickedSlide: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: ".morningCall-next",
        prevEl: ".morningCall-prev",
      },
      pagination: {
        el: ".morningCall-pagination",
        clickable: true,
      },
      on: {
        slideChange: function () {
          updateSlideOpacity(this);
        },
        init: function () {
          updateSlideOpacity(this);
        },
      },
    });
  };

  const updateSlideOpacity = (swiperInstance) => {
    swiperInstance.slides.forEach(slide => {
      slide.style.opacity = '0.5';
    });
    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (activeSlide) activeSlide.style.opacity = '1';
  };

  initSwiper(); // inicial

  // Dropdown toggle
  const toggleBtn = document.getElementById("btn-toggle-datas");
  const dropdown = document.getElementById("lista-datas");
  const label = document.getElementById("data-selecionada-label");

  toggleBtn?.addEventListener("click", () => {
    dropdown.classList.toggle("hidden");
    dropdown.classList.toggle("pointer-events-none");
  });

  document.addEventListener("click", (e) => {
    if (!document.getElementById("data-filtro").contains(e.target)) {
      dropdown.classList.add("hidden");
      dropdown.classList.add("pointer-events-none");
    }
  });

  // Filtro por mês
  const filterButtons = document.querySelectorAll("#lista-datas .data-btn");

 filterButtons.forEach(button => {
  button.addEventListener("click", () => {
    const selectedMonth = button.getAttribute("data-date"); // m-Y ou "all"
    label.textContent = button.textContent.trim();

    wrapper.innerHTML = "";

    let filtered = [];

    if (selectedMonth === "all") {
      filtered = allSlides;
    } else {
      filtered = allSlides.filter(slide => {
        return slide.getAttribute("data-month") === selectedMonth;
      });
    }

    if (filtered.length === 0) {
      wrapper.innerHTML = `<div class="text-center p-4 text-neutral-70 justify-center items-center">Nenhum vídeo para este mês.</div>`;
      swiperInstance?.destroy(true, true);
      return;
    }

    filtered.forEach(slide => {
      wrapper.appendChild(slide.cloneNode(true));
    });

    dropdown.classList.add("hidden");
    dropdown.classList.add("pointer-events-none");

    initSwiper(); // reinicializa o Swiper com os novos slides
  });
});


  // Modal vídeo
  const modal = document.getElementById("morningCallModal");
  const video = document.getElementById("morningCallVideo");

  morningCallSection.querySelectorAll('[data-modal-target="morningCallModal"]').forEach(el => {
    el.addEventListener('click', () => {
      const src = el.getAttribute("data-video-src");
      if (!src) return;
      video.querySelector('source').setAttribute("src", src);
      video.load();
      modal.classList.remove("hidden");
    });
  });

  modal?.querySelector(".close-modal")?.addEventListener("click", () => {
    modal.classList.add("hidden");
    video.pause();
  });
};

export default initializeSwiperMorningCall;
